
/** version match for all iOS 13 */
const iosVersion13 = `13.x.x`;
/** version match for iOS 14.4.0 only */
const iosVersionEqual14_4_0 = `>=14.0.0 <=14.4.0`;// eslint-disable-line @typescript-eslint/naming-convention
/** version match for iOS 14.4 with patch version 7 and greater */
const iosVersion14_4GreaterThenEqualPatch6 = `^14.4.7`;// eslint-disable-line @typescript-eslint/naming-convention
/** version match for iOS version 14.5 and greater */
const iosVersionGreaterThen14_5 = `>=14.5.0`;// eslint-disable-line @typescript-eslint/naming-convention

/**
 * want to match
 *  - iOS version 13
 *  - iOS version 14
 *    - exclude 14.4.1 to 14.4.6 due to bug that caused issues with realtime pitch shifting
 *  - iOS version 15
 *  - all future versions of iOS
 */
export const iosVersionSupportRealtimePitchShifting = `${iosVersion13} || ${iosVersionEqual14_4_0} || ${iosVersion14_4GreaterThenEqualPatch6} || ${iosVersionGreaterThen14_5}`;
